<template>
<el-tabs  style="margin-top:20px;">
  <el-tab-pane label="胰岛素数据统计">
    <HCLTable
      style="margin-top: 13px"
      :tableData="InsulinDataList"
      :tabType="insulinData"
      :pagesize="pagesize"
      :loading="loading"
    ></HCLTable>
  </el-tab-pane>
</el-tabs>
</template>
<script>
import auth from '@/auth/auth'
import HCLTable from './HCLTable.vue'
import exportToExcel from '@/lib/Export2Excel.js'
import {insulinData, invalidAccountData} from './dataStatisticsTaableHeader.json'
import publicMethod from './publicMethod'
export default {
  name: 'insulinStatistics',
  components: {
    HCLTable
  },
  data(){
    return {
      insulinData: insulinData,
      InsulinDataList:[],
      InsulinDataMap: {},
      accountInsulinDataMap: {},
      rangeList: {},
      outliers: {},
      loading: false,
      pagesize:10,
      invalidAccount: [],
      allowType: ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK'],
    }
  },
  methods:{
    exportExcel () {
      if(this.loading){
        this.$message.warning('数据量较大请等待加载完成')
      }else{
        let writeData = []
        for([account, accountValue] of Object.entries(this.accountInsulinDataMap)){
          writeData.push({
            'tableType': insulinData,
            'sheetName': account,
            'tableData': accountValue,
          })
        }
        writeData.push({
        'tableType': invalidAccountData,
        'tableData': this.invalidAccount,
        'sheetName': '无效账号'
        })
        if(Object.keys(this.accountInsulinDataMap).length){
          exportToExcel(writeData, 'Insulin statistics')
        }
      }
    },
    getInsulinBasal(dayData, dayTime){
    const HOUR = 3600
    let index =0, interval = 3600, startTime = 0, endTime = 0, speed = 0, totalBasal = 0, autoBasal = 0, autoBolus = 0
    const baseIndex = parseInt(dayTime/interval)
    let res = {}
    if(dayData.length){
      dayData.map((item, i)=>{
        let basalType=item[2];
        let recordIdPart=item[0].split('-')[3];
        if ('9999'!==recordIdPart && '65535'!==recordIdPart){
          startTime = item[1]
          // 非自动模式
          if(this.allowType.includes(basalType)){
            speed = item[4]
            endTime = item[1] + item[3]
            while(startTime < endTime){
              index = Math.floor(startTime/interval)
              let endIndex = Math.floor(endTime/interval)
              if(endIndex !== index){
                res[`Basal${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Basal${index-baseIndex+1}`] || 0), (interval-startTime%interval)/HOUR*speed)
                startTime = (index+1)*interval
              }else{
                res[`Basal${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Basal${index-baseIndex+1}`] || 0), (endTime-startTime)/HOUR*speed)
                startTime = endTime
              }
            }
            totalBasal += item[5]
          }
          // 自动模式
          else if('BAAM'===basalType){
            let duration = 360
            let autoModeData=item[7];
            endTime = startTime
            if (autoModeData) {
              autoModeData=JSON.parse(autoModeData);
              let microBolusJson=autoModeData['autoModeJSON'];
              let cur_auto_basal_total=0;
              let cur_auto_bolus_total=0;

              microBolusJson.map(microBolusitem => {
                endTime = endTime + duration
                while(startTime < endTime){
                  index = Math.floor(startTime/interval)
                  let endIndex = Math.floor(endTime/interval)
                  // 每6分钟输注量*0.05，每小时输注量*0.5
                  let autoBasalSpeed = microBolusitem['auto_basal_delivery']*0.5
                  let autoBolusSpeed = (microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery'])*0.5
                  // console.log({index, endIndex, interval, startTime, endTime, autoBasalSpeed, autoBolusSpeed})
                  if(endIndex !== index){
                    res[`Basal${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Basal${index-baseIndex+1}`] || 0), (interval-startTime%interval)/HOUR*autoBasalSpeed)
                    res[`Bolus${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Bolus${index-baseIndex+1}`] || 0), (interval-startTime%interval)/HOUR*autoBolusSpeed)
                    startTime = (index+1)*interval
                  }else{
                    res[`Basal${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Basal${index-baseIndex+1}`] || 0), (endTime-startTime)/HOUR*autoBasalSpeed)
                    res[`Bolus${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Bolus${index-baseIndex+1}`] || 0), (endTime-startTime)/HOUR*autoBolusSpeed)
                    startTime = endTime
                  }
                }
                cur_auto_basal_total += microBolusitem['auto_basal_delivery'];
                cur_auto_bolus_total += microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery'];
              })
              autoBasal += cur_auto_basal_total*0.05;
              autoBolus += cur_auto_bolus_total*0.05;
            }
          }
        }

      })
    res["totalBasal"] = publicMethod.addNumFixed(totalBasal, autoBasal)
    res['autoBolus'] = Math.round(autoBolus*100)/100
    // 存在相同属性，会将对应属性值相加
    res['totalBolus'] = Math.round(autoBolus*100)/100

    }
    return res
    },
    getInsulinBolus(dayData, dayTime){
      let index =0, interval = 3600, startTime = 0, totalBolus = 0
      const baseIndex = parseInt(dayTime/interval)
      let res = {}
      if(dayData.length){
        dayData.map(item=>{
          if(item[0].split('-')[3] < 8888){
            startTime = item[1]
            index = Math.floor(startTime/interval)
            res[`Bolus${index-baseIndex+1}`] = publicMethod.addNumFixed((res[`Bolus${index-baseIndex+1}`] || 0), item[4] + item[6])
            totalBolus += item[4] + item[6]
          }
        })
      res['totalBolus'] = Math.round(totalBolus*100)/100
      }
      return res
    },
    // 清空Insulin相关数据
    resetInsulin(){
      this.invalidAccount.length = 0
      this.InsulinDataList.length = 0
      this.InsulinDataMap = {}
      this.accountInsulinDataMap = {}
    },
    uploadToServer(postData) {
      // console.log('eqtrqw4: ', postData)
      // return 
      const accountList = {}
      this.rangeList = {}
      postData.map(item => {
        accountList[item.account] = ''
      })
      const getUidData = {
        'username': Object.keys(accountList)
      }
      this.loading = true
      this.$http.post('/api/v2.0/admin/user/get_uids', getUidData).then(res => {
        if(res.status === 200){
          this.resetInsulin()
          if(res.body.error === 0&&res.body.data.length!==0){
            res.body.data.map(item => {
              accountList[item[0]] = {uid:item[1], userName: item[2]}
            })
            let promiseList = []
            postData.map((postDataitem, index) => {
              const TS = auth.getTs(new Date(postDataitem.startDate)/1000, new Date(postDataitem.endDate)/1000)
              const accountName = postDataitem.account
              const userName = accountList[accountName].userName
              const startDate = postDataitem.startDate
              const dataSource = postDataitem.data_source==='实时'?'daopapp':'daoppdm'
              if(accountList[accountName].uid){
                const param = {
                  basal:{ts:TS},
                  bolus:{ts:TS},
                  data_source:dataSource,
                };
                this.InsulinDataMap[accountName] = this.InsulinDataMap[accountName] || {}
                this.InsulinDataMap[accountName][dataSource] = this.InsulinDataMap[accountName][dataSource]  || {}
                let promise = new Promise((resolve, reject) => {
                  this.$http.post('/api/v2.1/data/'+accountList[accountName].uid,param).then(res => {
                    if(res.status === 200){
                      if(res.body.error === 0){
                        res.data.data.basal.map((dayData, index) => {
                          let dayTime = new Date(startDate).getTime()/1000 + 86400*index
                          let day = publicMethod.formatterDate(startDate, index)

                          this.InsulinDataMap[accountName][dataSource][day] = this.getInsulinBasal(dayData, dayTime)
                          publicMethod.addProps(this.InsulinDataMap[accountName][dataSource][day], this.getInsulinBolus(res.data.data.bolus[index], dayTime))
                          this.InsulinDataMap[accountName][dataSource][day].userName = userName
                        })
                        resolve()
                      }
                    }else{
                      console.log("请求失败：", accountList[accountName], ': ', {accountName, dataSource} )
                    }
                  })
                })
                promiseList.push(promise)
              }else{
                this.invalidAccount.push({accountName})
              }
            })
            Promise.all(promiseList).then(() => {
              // console.log(JSON.stringify(this.InsulinDataMap))
              for([account, accountValue] of Object.entries(this.InsulinDataMap)){
                let tmpData = []
                for([dataSource, dataSourceValue] of Object.entries(accountValue)){
                  for([date, dateValue] of Object.entries(dataSourceValue)){
                    let dailyMap = { data_source:dataSource, date, account}
                    publicMethod.addProps(dailyMap, dateValue)
                    tmpData.push(dailyMap)
                  }
                }
                tmpData.sort((x,y) => {return new Date(x.date)-new Date(y.date)})
                this.InsulinDataList.push(...tmpData)
                this.accountInsulinDataMap[account] = tmpData
              }
              // console.log(JSON.stringify(this.InsulinDataList))
              // console.log(JSON.stringify(this.accountInsulinDataMap))
              this.loading = false
              publicMethod.invalidAccountMSG(this.invalidAccount, this)
            })
          }else{
            this.loading = false
            postData.map(item => {
              this.invalidAccount.push({accountName:item.account})
            })
            publicMethod.invalidAccountMSG(this.invalidAccount, this)
          }
        }else{

        }
      })
    },
  },
}
</script>
<style scoped>
  >>> .el-table td>div{
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// insulinStatistics.vue?62308db3